export const getAttributeKey = (index) => `attribute${index}`;

export const getAttributeItemsKey = (index) => `attribute_${index}`;

export const findNumericValues = (numericValues, attributeId) =>
    numericValues?.find(item => item.attribute_id === attributeId) ?? {};
export const getAdditionalPriceFromNumericAttributes = (productBySlug) => {
    let additionalPrice = 0;

    [1, 2, 3].forEach((index) => {
        const { product, numeric_values } = productBySlug || {};
        const attribute = product?.[getAttributeKey(index)] ?? null;

        const isNumeric = attribute?.attribute_type === 'numeric';

        if (isNumeric) {

            // Numeric attribute configuration
            const numericConfig = findNumericValues(numeric_values, attribute?.attribute_id);
            const {
                current_value = 0,
                override_default_value = 0,
                override_price_per_unit = 0,
            } = numericConfig;

            const pricePerUnitNumber = parseFloat(override_price_per_unit) || 0;

            additionalPrice += pricePerUnitNumber * (current_value - override_default_value);
        }
    });
    return additionalPrice;
};

export const getAttributeValues = (product) => {
    // Helper function to safely extract attribute values
    const getAttributeValue = (attributeId, attributeNumber) => {
        if (!attributeId) return null;

        // Check if it's a numeric attribute
        const numericAttribute = product.numeric_values?.find(attr => attr.attribute_id === attributeId);
        if (numericAttribute) {
            const valueWithUnit = numericAttribute.current_value + " " + (numericAttribute.attribute?.numeric_config?.unit || numericAttribute.unit || "");
            return valueWithUnit;
        }

        // Otherwise try to find in regular attributes
        const attributeItems = product.attributes_items?.[`attribute_${attributeNumber}`]?.items || {};
        return Object.values(attributeItems).find(attr => attr.attribute_item_id === attributeId)?.attribute_item_name ?? "";
    };

    return {
        attribute1Value: getAttributeValue(product.product_variant_attr1, 1),
        attribute2Value: getAttributeValue(product.product_variant_attr2, 2),
        attribute3Value: getAttributeValue(product.product_variant_attr3, 3)
    };
};

// Generated for order_buy.jsx usage, redefine if needed elsewhere
export const getNumericAttributeValuesWithNames = (product) => {
    // Helper function to safely extract attribute values
    const getAttributeNameWithValue = (attributeId, attributeNumber) => {
        if (!attributeId) return null;

        // Check if it's a numeric attribute
        const numericAttribute = product.numeric_values?.find(attr => attr.attribute_id === attributeId);
        if (numericAttribute) {
            const value = numericAttribute.current_value + " " + (numericAttribute.attribute?.numeric_config?.unit || numericAttribute.unit || "");
            const name = numericAttribute.attribute_name || "";
            return `${name}: ${value}`;
        }

        return null;
    };

    return {
        attribute1AsNameWithValue: getAttributeNameWithValue(product.product_variant_attr1, 1),
        attribute2AsNameWithValue: getAttributeNameWithValue(product.product_variant_attr2, 2),
        attribute3AsNameWithValue: getAttributeNameWithValue(product.product_variant_attr3, 3)
    };
};

export const getItemVolume = (item) => {
    if (item.order_item_volume) {
        return (parseFloat(item.order_item_volume)).toFixed(2);
    }
    if (item.variant && item.variant.product_variant_volume) {
        return (item.variant.product_variant_volume * item.order_item_qty).toFixed(2);
    }
    if (item.product && item.product.product_volume) {
        return (item.product.product_volume * item.order_item_qty).toFixed(2);
    }
    return 0;
};

export const getItemWeight = (item) => {
    if (item.order_item_weight) {
        return (parseFloat(item.order_item_weight)).toFixed(2);
    }
    if (item.variant && item.variant.product_variant_weight) {
        return (item.variant.product_variant_weight * item.order_item_qty).toFixed(2);
    }
    if (item.product && item.product.product_weight) {
        return (item.product.product_weight * item.order_item_qty).toFixed(2);
    }
    return 0;
};